var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree-content',{attrs:{"path":_vm.path,"loading-path":_vm.loadingPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }